import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { AdminRelationship, ManagementLink } from '../../../../models/csp.model';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'dd-wgs-tenant-managements',
  templateUrl: './wgs-tenant-management.component.html',
  styleUrls: ['./wgs-tenant-management.component.css']
})
export class WGSTenantManagementComponent implements OnInit, OnDestroy {
  

  readonly Object = Object;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private tenantId: string;

  public tenantManagementDataLoaded = false;
  public isAdminRelationshipsLoading = false;
  public adminRelationships: AdminRelationship[];
  public managementLinks: ManagementLink[] = [];


  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(param => {
      this.tenantId = param.get('tenantId');
    })

  }

  public openTab() {
    if (!this.tenantManagementDataLoaded) {
      this.tenantManagementDataLoaded = true
    }
  }


  public openLinkInNewTab(url: string): void {
    window.open(url, "_blank");
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
